import ahoy from 'ahoy.js';

const urlBase = '/analytics';

export default function () {
  ahoy.configure({
    // Dummy header which forces the ahoy library to use XHR instead of a form
    // submit which avoids a CORB error in Chrome.
    headers: {
      'X-Ahoy': true,
    },

    visitsUrl: `${urlBase}/visits`,
    eventsUrl: `${urlBase}/events`,
  });
}
